module.exports = __webpack_public_path__ + "static/img/avtar.fe01a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avtar.png
// module id = gAHu
// module chunks = 0